<template>
  <section class="comp-section">
    <div class="section-header">
      <h3 class="section-title">Modals</h3>
      <div class="line"></div>
    </div>
    <div class="card">
      <div class="card-header">
        <h4 class="card-title">Modal components</h4>
      </div>
      <div class="card-body">
        <p class="card-text">
          Below is a static modal example (meaning its position and display have been
          overridden). Included are the modal header, modal body (required for padding),
          and modal footer (optional). We ask that you include modal headers with dismiss
          actions whenever possible, or provide another explicit dismiss action.
        </p>
        <div class="modal-1 static-modal" tabindex="-1" role="dialog">
          <div class="modal-dialog mb-2" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title mt-0">Modal title</h5>
                <button type="button" class="close" :aria-label="$t('close')">
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div class="modal-body">
                <p class="card-text">Modal body text goes here.</p>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary me-2">Close</button>
                <button type="button" class="btn btn-primary">Save changes</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-header">
        <h4 class="card-title">Basic Modal</h4>
      </div>
      <div class="card-body">
        <!-- Simple demo-->
        <button
          class="btn btn-primary me-1"
          type="button"
          data-bs-toggle="modal"
          data-original-title="test"
          data-bs-target="#exampleModal"
        >
          Simple
        </button>
        <div
          class="modal fade"
          id="exampleModal"
          tabindex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Modal title</h5>
                <button
                  class="close"
                  type="button"
                  data-bs-dismiss="modal"
                  :aria-label="$t('close')"
                  data-original-title=""
                  title=""
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div class="modal-body">...</div>
              <div class="modal-footer">
                <button
                  class="btn btn-primary"
                  type="button"
                  data-bs-dismiss="modal"
                  data-original-title=""
                  title=""
                >
                  Close
                </button>
                <button
                  class="btn btn-secondary"
                  type="button"
                  data-original-title=""
                  title=""
                >
                  Save changes
                </button>
              </div>
            </div>
          </div>
        </div>
        <!-- Scrolling long content-->
        <button
          class="btn btn-primary me-1"
          type="button"
          data-bs-toggle="modal"
          data-bs-target="#exampleModalLong"
          data-original-title=""
          title=""
        >
          Scrolling long content
        </button>
        <div
          class="modal fade"
          id="exampleModalLong"
          tabindex="-1"
          role="dialog"
          aria-labelledby="exampleModalLongTitle"
          aria-hidden="true"
        >
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLongTitle">Modal title</h5>
                <button
                  class="close"
                  type="button"
                  data-bs-dismiss="modal"
                  :aria-label="$t('close')"
                  data-original-title=""
                  title=""
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div class="modal-body">
                <p>
                  Lorem Ipsum is simply dummy text of the printing and typesetting
                  industry. Lorem Ipsum has been the industry's standard dummy text ever
                  since the 1500s, when an unknown printer took a galley of type and
                  scrambled it to make a type specimen book. It has survived not only five
                  centuries,
                </p>
                <p>
                  but also the leap into electronic typesetting, remaining essentially
                  unchanged. It was popularised in the 1960s with the release of Letraset
                  sheets containing Lorem Ipsum passages, and more recently with desktop
                  publishing
                </p>
                <p>
                  Lorem Ipsum is simply dummy text of the printing and typesetting
                  industry. Lorem Ipsum has been the industry's standard dummy text ever
                  since the 1500s, when an unknown printer took a galley of type and
                  scrambled it to make a type specimen book. It has survived not only five
                  centuries,
                </p>
                <p>
                  but also the leap into electronic typesetting, remaining essentially
                  unchanged. It was popularised in the 1960s with the release of Letraset
                  sheets containing Lorem Ipsum passages, and more recently with desktop
                  publishing
                </p>
                <p>
                  Lorem Ipsum is simply dummy text of the printing and typesetting
                  industry. Lorem Ipsum has been the industry's standard dummy text ever
                  since the 1500s, when an unknown printer took a galley of type and
                  scrambled it to make a type specimen book. It has survived not only five
                  centuries,
                </p>
                <p>
                  but also the leap into electronic typesetting, remaining essentially
                  unchanged. It was popularised in the 1960s with the release of Letraset
                  sheets containing Lorem Ipsum passages, and more recently with desktop
                  publishing
                </p>
                <p>
                  Lorem Ipsum is simply dummy text of the printing and typesetting
                  industry. Lorem Ipsum has been the industry's standard dummy text ever
                  since the 1500s, when an unknown printer took a galley of type and
                  scrambled it to make a type specimen book. It has survived not only five
                  centuries,
                </p>
                <p>
                  but also the leap into electronic typesetting, remaining essentially
                  unchanged. It was popularised in the 1960s with the release of Letraset
                  sheets containing Lorem Ipsum passages, and more recently with desktop
                  publishing
                </p>
                <p>
                  Lorem Ipsum is simply dummy text of the printing and typesetting
                  industry. Lorem Ipsum has been the industry's standard dummy text ever
                  since the 1500s, when an unknown printer took a galley of type and
                  scrambled it to make a type specimen book. It has survived not only five
                  centuries,
                </p>
                <p>
                  but also the leap into electronic typesetting, remaining essentially
                  unchanged. It was popularised in the 1960s with the release of Letraset
                  sheets containing Lorem Ipsum passages, and more recently with desktop
                  publishing
                </p>
                <p>
                  Lorem Ipsum is simply dummy text of the printing and typesetting
                  industry. Lorem Ipsum has been the industry's standard dummy text ever
                  since the 1500s, when an unknown printer took a galley of type and
                  scrambled it to make a type specimen book. It has survived not only five
                  centuries,
                </p>
                <p>
                  but also the leap into electronic typesetting, remaining essentially
                  unchanged. It was popularised in the 1960s with the release of Letraset
                  sheets containing Lorem Ipsum passages, and more recently with desktop
                  publishing
                </p>
              </div>
              <div class="modal-footer">
                <button
                  class="btn btn-secondary"
                  type="button"
                  data-bs-dismiss="modal"
                  data-original-title=""
                  title=""
                >
                  Close
                </button>
                <button
                  class="btn btn-primary"
                  type="button"
                  data-original-title=""
                  title=""
                >
                  Save changes
                </button>
              </div>
            </div>
          </div>
        </div>
        <!-- Vertically centered modal-->
        <button
          class="btn btn-primary me-1"
          type="button"
          data-bs-toggle="modal"
          data-bs-target="#exampleModalCenter"
          data-original-title=""
          title=""
        >
          Vertically centered
        </button>
        <div
          class="modal fade"
          id="exampleModalCenter"
          tabindex="-1"
          role="dialog"
          aria-labelledby="exampleModalCenter"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Modal title</h5>
                <button
                  class="close"
                  type="button"
                  data-bs-dismiss="modal"
                  :aria-label="$t('close')"
                  data-original-title=""
                  title=""
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div class="modal-body">
                <p>
                  Lorem Ipsum is simply dummy text of the printing and typesetting
                  industry. Lorem Ipsum has been the industry's standard dummy text ever
                  since the 1500s,
                </p>
              </div>
              <div class="modal-footer">
                <button
                  class="btn btn-secondary"
                  type="button"
                  data-original-title=""
                  title=""
                >
                  Close
                </button>
                <button
                  class="btn btn-primary"
                  type="button"
                  data-original-title=""
                  title=""
                >
                  Save changes
                </button>
              </div>
            </div>
          </div>
        </div>
        <!-- Tooltips and popovers modal-->
        <button
          class="btn btn-primary me-1"
          type="button"
          data-bs-toggle="modal"
          data-bs-target="#tooltipmodal"
          data-original-title=""
          title=""
        >
          Tooltips and popovers
        </button>
        <div
          class="modal fade"
          id="tooltipmodal"
          tabindex="-1"
          role="dialog"
          aria-labelledby="tooltipmodal"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Modal title</h5>
                <button
                  class="close"
                  type="button"
                  data-bs-dismiss="modal"
                  :aria-label="$t('close')"
                  data-original-title=""
                  title=""
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div class="modal-body">
                <h5>Popover in a modal</h5>
                <p>
                  This
                  <a
                    class="btn btn-primary popover-test"
                    href="javascript:;"
                    role="button"
                    title=""
                    data-content="Popover body content is set in this attribute."
                    data-container="#exampleModalPopovers"
                    data-original-title="Popover title"
                    >button</a
                  >
                  triggers a popover on click.
                </p>
                <hr />
                <h5>Tooltips in a modal</h5>
                <p>
                  <a
                    class="tooltip-test"
                    href="javascript:;"
                    title=""
                    data-container="#exampleModalPopovers"
                    data-original-title="Tooltip"
                    >This link</a
                  >
                  and
                  <a
                    class="tooltip-test"
                    href="javascript:;"
                    title=""
                    data-container="#exampleModalPopovers"
                    data-original-title="Tooltip"
                    >that link</a
                  >
                  have tooltips on hover.
                </p>
              </div>
              <div class="modal-footer">
                <button
                  class="btn btn-secondary"
                  type="button"
                  data-bs-dismiss="modal"
                  data-original-title=""
                  title=""
                >
                  Close
                </button>
                <button
                  class="btn btn-primary"
                  type="button"
                  data-original-title=""
                  title=""
                >
                  Save changes
                </button>
              </div>
            </div>
          </div>
        </div>
        <!-- Using the grid modal-->
        <button
          class="btn btn-primary me-1 mt-1"
          type="button"
          data-bs-toggle="modal"
          data-bs-target="#grid-modal"
          data-original-title=""
          title=""
        >
          Using the grid
        </button>
        <div
          class="modal fade"
          id="grid-modal"
          tabindex="-1"
          role="dialog"
          aria-labelledby="grid-modal"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Modal title</h5>
                <button
                  class="close"
                  type="button"
                  data-bs-dismiss="modal"
                  :aria-label="$t('close')"
                  data-original-title=""
                  title=""
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div class="modal-body grid-showcase">
                <div class="container-fluid bd-example-row">
                  <div class="row">
                    <div class="col-md-4"><span>.col-md-4</span></div>
                    <div class="col-md-4 ml-auto">
                      <span>.col-md-4 .ml-auto</span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-3 ml-auto">
                      <span>.col-md-3 .ml-auto</span>
                    </div>
                    <div class="col-md-2 ml-auto">
                      <span>.col-md-2 .ml-auto</span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6 ml-auto">
                      <span>.col-md-6 .ml-auto</span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-9">
                      <span>Level 1: .col-sm-9</span>
                      <div class="row">
                        <div class="col-8 col-sm-6">
                          <span>Level 2: .col-8 .col-sm-6</span>
                        </div>
                        <div class="col-4 col-sm-6">
                          <span>Level 2: .col-4 .col-sm-6</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button
                  class="btn btn-secondary"
                  type="button"
                  data-bs-dismiss="modal"
                  data-original-title=""
                  title=""
                >
                  Close
                </button>
                <button
                  class="btn btn-primary"
                  type="button"
                  data-original-title=""
                  title=""
                >
                  Save changes
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-header">
        <h4 class="card-title">Varying modal content</h4>
      </div>
      <div class="card-body btn-showcase">
        <button
          class="btn btn-primary me-1"
          type="button"
          data-bs-toggle="modal"
          data-bs-target="#exampleModalfat"
          data-whatever="@mdo"
          data-original-title=""
          title=""
        >
          Open modal for @mdo
        </button>
        <button
          class="btn btn-primary me-1"
          type="button"
          data-bs-toggle="modal"
          data-bs-target="#exampleModalmdo"
          data-whatever="@fat"
          data-original-title=""
          title=""
        >
          Open modal for @fat
        </button>
        <button
          class="btn btn-primary me-1"
          type="button"
          data-bs-toggle="modal"
          data-bs-target="#exampleModalgetbootstrap"
          data-whatever="@getbootstrap"
          data-original-title=""
          title=""
        >
          Open modal for @getbootstrap
        </button>
        <div
          class="modal fade"
          id="exampleModalfat"
          tabindex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel2">New message</h5>
                <button
                  class="close"
                  type="button"
                  data-bs-dismiss="modal"
                  :aria-label="$t('close')"
                  data-original-title=""
                  title=""
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div class="modal-body">
                <form>
                  <div class="form-group">
                    <label class="col-form-label" for="recipient-name">Recipient:</label>
                    <input
                      class="form-control"
                      type="text"
                      value="@fat"
                      data-original-title=""
                      title=""
                    />
                  </div>
                  <div class="form-group">
                    <label class="col-form-label" for="message-text">Message:</label>
                    <textarea class="form-control" id="message-text"></textarea>
                  </div>
                </form>
              </div>
              <div class="modal-footer">
                <button
                  class="btn btn-secondary"
                  type="button"
                  data-bs-dismiss="modal"
                  data-original-title=""
                  title=""
                >
                  Close
                </button>
                <button
                  class="btn btn-primary"
                  type="button"
                  data-original-title=""
                  title=""
                >
                  Send message
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          class="modal fade"
          id="exampleModalmdo"
          tabindex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">New message</h5>
                <button
                  class="close"
                  type="button"
                  data-bs-dismiss="modal"
                  :aria-label="$t('close')"
                  data-original-title=""
                  title=""
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div class="modal-body">
                <form>
                  <div class="form-group">
                    <label class="col-form-label" for="recipient-name">Recipient:</label>
                    <input
                      class="form-control"
                      id="recipient-name"
                      type="text"
                      value="@Mat"
                      data-original-title=""
                      title=""
                    />
                  </div>
                  <div class="form-group">
                    <label class="col-form-label" for="message-text">Message:</label>
                    <textarea class="form-control"></textarea>
                  </div>
                </form>
              </div>
              <div class="modal-footer">
                <button
                  class="btn btn-secondary"
                  type="button"
                  data-bs-dismiss="modal"
                  data-original-title=""
                  title=""
                >
                  Close
                </button>
                <button
                  class="btn btn-primary"
                  type="button"
                  data-original-title=""
                  title=""
                >
                  Send message
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          class="modal fade"
          id="exampleModalgetbootstrap"
          tabindex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">New message</h5>
                <button
                  class="close"
                  type="button"
                  data-bs-dismiss="modal"
                  :aria-label="$t('close')"
                  data-original-title=""
                  title=""
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div class="modal-body">
                <form>
                  <div class="form-group">
                    <label class="col-form-label" for="recipient-name">Recipient:</label>
                    <input
                      class="form-control"
                      type="text"
                      value="@getbootstrap"
                      data-original-title=""
                      title=""
                    />
                  </div>
                  <div class="form-group">
                    <label class="col-form-label" for="message-text">Message:</label>
                    <textarea class="form-control"></textarea>
                  </div>
                </form>
              </div>
              <div class="modal-footer">
                <button
                  class="btn btn-secondary"
                  type="button"
                  data-bs-dismiss="modal"
                  data-original-title=""
                  title=""
                >
                  Close
                </button>
                <button
                  class="btn btn-primary"
                  type="button"
                  data-original-title=""
                  title=""
                >
                  Send message
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-header">
        <h4 class="card-title">Sizes modal</h4>
      </div>
      <div class="card-body">
        <!-- Extra Large modal -->
        <button
          type="button"
          class="btn btn-primary me-1"
          data-bs-toggle="modal"
          data-bs-target=".bd-example-modal-xl"
        >
          Extra large modal
        </button>
        <div
          class="modal fade bd-example-modal-xl"
          tabindex="-1"
          role="dialog"
          aria-labelledby="myLargeModalLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-xl">
            <div class="modal-content">
              <div class="modal-header">
                <h4 class="modal-title" id="myLargeModalLabel"></h4>
                <button
                  class="close"
                  type="button"
                  data-bs-dismiss="modal"
                  :aria-label="$t('close')"
                  data-original-title=""
                  title=""
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div class="modal-body">...</div>
            </div>
          </div>
        </div>
        <!-- Large modal-->
        <button
          class="btn btn-primary me-1"
          type="button"
          data-bs-toggle="modal"
          data-bs-target=".bd-example-modal-lg"
          data-original-title=""
          title=""
        >
          Large modal
        </button>
        <div
          class="modal fade bd-example-modal-lg"
          tabindex="-1"
          role="dialog"
          aria-labelledby="myLargeModalLabel1"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="modal-header">
                <h4 class="modal-title" id="myLargeModalLabel1">Large modal</h4>
                <button
                  class="close"
                  type="button"
                  data-bs-dismiss="modal"
                  :aria-label="$t('close')"
                  data-original-title=""
                  title=""
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div class="modal-body">...</div>
            </div>
          </div>
        </div>
        <!-- Small modal-->
        <button
          class="btn btn-primary me-1"
          type="button"
          data-bs-toggle="modal"
          data-bs-target=".bd-example-modal-sm"
          data-original-title=""
          title=""
        >
          Small modal
        </button>
        <div
          class="modal fade bd-example-modal-sm"
          tabindex="-1"
          role="dialog"
          aria-labelledby="mySmallModalLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-sm">
            <div class="modal-content">
              <div class="modal-header">
                <h4 class="modal-title" id="mySmallModalLabel">Small modal</h4>
                <button
                  class="close"
                  type="button"
                  data-bs-dismiss="modal"
                  :aria-label="$t('close')"
                  data-original-title=""
                  title=""
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div class="modal-body">...</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
